module.exports = __webpack_public_path__ + "img/Race.9c8ba255.svg";